import { z } from "zod";
import { phoneSchema, textSchema, selectSchema, emailSchema, dateSchema } from "../../../shared/lib/schemas/common.schema";
import { yesNoRejectedOptions } from "../../../shared/constants/options";
import { residentTypeOptions } from "../constants/options";
import { makeOptional } from "../../../shared/lib/helpers/schema.helpers";
import { NO_EMAIL_AVAILABLE_OPTION } from "@/features/volunteers/schemas/volunteers.schema";

export const homeOwnerFormSchema = z.object({
    name:  textSchema(),

    email: z.union([emailSchema, z.literal(NO_EMAIL_AVAILABLE_OPTION)]),

    phone: makeOptional(phoneSchema),

    primaryLanguage: makeOptional(textSchema()),

    secondaryContact: makeOptional(textSchema()),

    secondaryPhone: makeOptional(phoneSchema),

    dateOfBirth: makeOptional(dateSchema, "date"),

    residentType: makeOptional(selectSchema(residentTypeOptions)),

    medicalNeeds: makeOptional(textSchema()),
    
    numChildrenUnder18: makeOptional(
        z.number()
            .min(1, "Required")
            .max(100, "Cannot exceed 100 children"), 
        "number"
    ),

    isFirstResponder: makeOptional(z.string()),

    isSingleParent: makeOptional(z.string()),

    isVeteran: makeOptional(z.string()),

    appliedFEMA: makeOptional(z.string()),
    
    femaStatus: z.enum(["yes", "no", "rejected"]).nullable().optional(),

    appliedSBA: makeOptional(z.string()),

    sbaStatus: z.enum(["yes", "no", "rejected"]).nullable().optional(),

    safetyConcerns: makeOptional(textSchema("lg")),

    notesAndComments: makeOptional(textSchema("lg")),

    ownerStory: makeOptional(textSchema("lg")),

})

export const updateHomeOwnerFormSchema = homeOwnerFormSchema.partial()

export type HomeOwnerFormType = z.infer<typeof homeOwnerFormSchema>

export type UpdateHomeOwnerFormType = z.infer<typeof updateHomeOwnerFormSchema>

export const mapHomeOwnerSchema = z.object({
    address:  textSchema(),

})
export const MapFormSchema = mapHomeOwnerSchema.partial();
export type MapFormType = z.infer<typeof MapFormSchema>
